<template>
    <md-menu md-direction="bottom-end" md-align-trigger md-close-on-click>
        <md-button class="md-just-icon md-primary" md-menu-trigger>
            <md-icon> more_horiz</md-icon>
        </md-button>

        <md-menu-content>
            <li>
                <a @click="actionEdit">Edit</a>
            </li>
            <li>
                <a @click="actionShowModal">Delete</a>
            </li>
        </md-menu-content>
        <delete-prompt-modal @cancel="onCancel" @confirmation="actionDelete" :name="organization.name" :show-modal="showDeleteModal"/>
    </md-menu>
</template>

<script>
    import DeletePromptModal from "../../modals/DeletePromptModal";

    export default {
        name: "OrganizationsMoreDropdown",
        components: {DeletePromptModal},
        props: {
            organization: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                showDeleteModal: false
            }
        },
        methods: {
            onCancel() {
                this.showDeleteModal = false;
            },
            actionShowModal(){
                this.showDeleteModal = true;
            },
            actionEdit() {
                let path = this.$enums.RoutePathEnum.ORGANIZATION_UPDATE.replace(':tab', '');
                path = path.replace(':id', this.organization.id);

                this.$router.push(path);
            },

            actionDelete() {
                this.$api.deleteOrganization({
                    segments: {
                        id: this.organization.id,
                    },
                }).then(() => {
                    this.$bus.emit('updateIndex')
                })
                this.showDeleteModal = false;
            },
        }
    }
</script>
